<template>
  <div>
    <div class="add-appointment" v-show="!loading">
      <!-- Header -->
      <header-vue
        :popup="showThePopup"
        :add-option="addOption"
        :hide-add-option="hideAddOption"
      />

      <!-- Section -->
      <section-vue
        :popup="showThePopup"
        :add-option-selected="addOptionSelected"
      />

      <!-- Popup -->
      <div class="popup" v-show="showPopup">
        <transition name="pop">
          <popup-vue v-if="showPopup" :hide="hideThePopup" />
        </transition>
      </div>

      <div class="popup" v-show="overLapCheck === 'ASK_USER'">
        <transition name="pop">
          <over-lap-popup v-show="overLapCheck === 'ASK_USER'" />
        </transition>
      </div>
    </div>

    <!-- Loader -->
    <div class="loader-container" v-if="loading">
      <loader-vue />
    </div>
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import SectionVue from "./Section.vue";
import PopupVue from "./Popup.vue";
import LoaderVue from "../common/Loader.vue";
import OverLapPopup from "./OverLapPopup";
import { addEditAppointmentHomeMixin } from "../../../mixins/addEditAppointmentHomeMixin";
import { mapGetters, mapMutations } from "vuex";
import { authMixin } from "../../../mixins/authMixin.js";

export default {
  name: "AddAppointmentHome",
  mixins: [
    authMixin, // For authentication
    addEditAppointmentHomeMixin // For add edit appointment common functions
  ],
  data() {
    return {
      showPopup: false,
      name: ""
    };
  },
  components: {
    HeaderVue,
    SectionVue,
    PopupVue,
    LoaderVue,
    OverLapPopup
  },
  computed: {
    ...mapGetters({
      getAppointmentSubmitted: "getAppointmentSubmitted", // Check if appointent has been submitted and page can be changed
      loading: "getIsLoadingAddAppointment", // Should loading screen be shown
      searchValue: "getSearchValue", // Search value
      overLapCheck: "getOverLapCheck" // Weather overlap is allowed or not
    })
  },
  methods: {
    ...mapMutations({
      setSubmitted: "setSubmitted", // Set submitted to false when done
      restoreDefault: "restoreDefault", // Restoring form fields to their default values
      setChangeToEdit: "setChangeToEdit" // Set this to false to specify that this add appointment is not edit by default
    }),

    /**
     * Method for showing popop
     */
    showThePopup() {
      this.showPopup = true;
    },
    /**
     * Method for hiding popup
     */
    hideThePopup() {
      this.showPopup = false;
    }
  },
  watch: {
    /**
     * watching value of is submitted, to know when the form has been submitted and the route needs to change
     */
    getAppointmentSubmitted(value) {
      if (value) {
        this.$router.push("/daily");
        this.setSubmitted(false);
      }
    }
  },
  created() {
    this.prevSearchVal = this.searchValue;
  },
  beforeRouteLeave(to, from, next) {
    // Step 2: Restore defaults
    this.restoreDefault();

    // Step 3: Change edit to add
    this.setChangeToEdit(false);

    // Step 4: Next
    next();
  }
};
</script>

<style scoped>
div > input {
  color: #666;
}

.popup {
  position: fixed;
  z-index: 9999;
  display: block;
  bottom: 0px;
  left: 0px;
}

/* stage 2. Entered */
.pop-enter-active {
  animation: pop-in 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.pop-leave-active {
  animation: pop-out 0.2s ease-in-out forwards;
}

@keyframes pop-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
